var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a87e6b;}.cls-2{fill:#be927c;}.cls-3{fill:#db5669;}.cls-4{fill:#f26674;}.cls-5{fill:#c4455e;}.cls-6{fill:#f6ccaf;}.cls-7{fill:#ffdec7;}.cls-8{fill:#374f68;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Customer service") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customer_service",
    "data-name": "Customer service"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,12V30.14H13V12a11,11,0,1,1,22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35,12V30.14H15V12A11,11,0,0,1,25,1.05,11,11,0,0,1,35,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41,36.2V47H7V36.2a6,6,0,0,1,4.37-5.76,29.13,29.13,0,0,1,4.28-.68C22.07,28.85,19.45,29,27,29l8.85,1.26A6,6,0,0,1,41,36.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41,36.2V45H12a3,3,0,0,1-3-3V35.2a6,6,0,0,1,2.37-4.76,4.92,4.92,0,0,1,.78-.18c12.67-1.81,11.11-1.8,23.7,0A6,6,0,0,1,41,36.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24,32l-4,4-4.35-6.24L21,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23,31l-2.16,2.16A1,1,0,0,1,19.32,33l-2.4-3.44L21,29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "32.35 29.76 28 36 24 32 27 29 32.35 29.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M15,39v8H13V39A1,1,0,0,1,15,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35,39v8H33V39A1,1,0,0,1,35,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.29,42.29a1,1,0,0,1,1.42,1.42A1,1,0,0,1,23.29,42.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.29,38.29a1,1,0,0,1,1.42,1.42A1,1,0,0,1,23.29,38.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M31,12c-.63,9-.49,9.34-1.56,11a6.45,6.45,0,0,1-11.87-3c-.15-2.19-.38-5.36-.57-8,1.54-.51,3-1.05,4-3C24.28,11.46,27.39,12,31,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M31,12c-.63,9-.49,9.34-1.56,11a6,6,0,0,1-1.61,1.73A6.44,6.44,0,0,1,19.57,19c-.11-1.61-.5-7-.56-7.85A5.34,5.34,0,0,0,21,9C24.28,11.46,27.39,12,31,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M33,24H26a1,1,0,0,1,0-2h7a1,1,0,0,0,1-1V17.73a1,1,0,0,1,2,0V21A3,3,0,0,1,33,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M27,25.26V29l-3,3-3-3V25.26A6.46,6.46,0,0,0,27,25.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M27,25.26V29l-2,2-2-2V25.92A6.46,6.46,0,0,0,27,25.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25,31l2.16,2.16A1,1,0,0,0,28.68,33l2.4-3.44L27,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36,15c0,1.68.27,3-1,3.73-.65.38-1,.27-4.5.27l.43-6H34A2,2,0,0,1,36,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.5,19c-3.72,0-3.89.09-4.5-.27C11.76,18,12,16.88,12,15a2,2,0,0,1,2-2h3.07C17.42,17.81,17.32,16.48,17.5,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.36,17A4.48,4.48,0,0,1,15,16.73C13.76,16,14,14.88,14,13h3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.64,17A4.48,4.48,0,0,0,33,16.73c1.24-.72,1-1.85,1-3.73H30.93Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.304e83cd4b7fce53bc32892f0707e0e9.svg";
export { ForwardRef as ReactComponent };